import { DocumentsSection } from './DocumentsSection/DocumentsSection';
import { HighlightsSection } from './HighlightsSection/HighlightsSection';
import { KeyDetailsSection } from './KeyDetailsSection/KeyDetailsSection';
import { NextStepsSection } from './NextStepsSection/NextStepsSection';
import { RelatedCasesSection } from './RelatedCasesSection/RelatedCasesSection';
import { ReportOverview } from './ReportOverview/ReportOverview';
import { StatusSection } from './StatusSection/StatusSection';

import type { DocketDetailSections } from './types';

export function ReportSectionsView({
  sections,
}: {
  sections: DocketDetailSections;
}) {
  const { header, settlement_card, at_a_glance, case_overview, status } =
    sections;
  const { key_details, next_steps, related_cases, highlights, documents } =
    sections;

  return (
    <>
      <ReportOverview
        header={header}
        settlement_card={settlement_card}
        at_a_glance={at_a_glance}
      />
      <HighlightsSection
        case_overview={case_overview}
        highlights={highlights.recap_document_highlights ?? []}
      />
      <StatusSection status={status} />
      <KeyDetailsSection key_details={key_details} />
      <DocumentsSection documents={documents} />
      <NextStepsSection next_steps={next_steps} />
      <RelatedCasesSection related_cases={related_cases} />
    </>
  );
}
